import VirtualKeyboardContext from '../../../../shared/components/utils/context/virtualKeyboardContext';
import { selectMagicRemoteEnabled } from '../../../../shared/store/slices/magicRemote.slice';
import { useAppSelector } from '../../../../shared/store/hooks';
import { useContext, useState } from 'react';
import KeyNumbers from '@components/atoms/container/keyNumbers';

function NumbersKey({ index }: { index: number[] }) {
  const enabled = useAppSelector(selectMagicRemoteEnabled);
  const { listIndex, listFocused, onClick } = useContext(
    VirtualKeyboardContext
  );
  const [hovered, setHovered] = useState(false);
  const focused = !enabled && listFocused && index.includes(listIndex);
  const numbersButton = 123;
  return (
    <KeyNumbers
      onClick={() => index.length && onClick(index[0])}
      onPointerEnter={() => setHovered(true)}
      onPointerLeave={() => setHovered(focused)}
      focused={hovered || focused}
    >
      {numbersButton}
    </KeyNumbers>
  );
}

export default NumbersKey;
